import { useMemo } from 'react';
import { TRAFFIC_HEX, AOW_CARD_COLORS, splitHlosByType } from '../shared/constants';

export function AowCard({ aow, renderBox }) {
  const { outputGroup, iocItems } = splitHlosByType(aow.hlos || []);
  const hasOutputs = outputGroup.length > 0;
  const hasOutcomes = iocItems.length > 0;

  const targetNote = useMemo(() => {
    const all = (aow.indicators || []).filter(i => !i.isUnaligned);
    const withTarget = all.filter(i => i.achievementPct !== null);
    if (withTarget.length < all.length && withTarget.length > 0) {
      return `(${withTarget.length}/${all.length} with targets)`;
    }
    return null;
  }, [aow.indicators]);

  return (
    <div
      className="rounded-2xl border-2 overflow-hidden"
      style={{ borderColor: AOW_CARD_COLORS.header.border }}
    >
      {/* AoW header banner */}
      <div
        className="flex items-center justify-between px-4 py-2.5"
        style={{ backgroundColor: AOW_CARD_COLORS.header.bg }}
      >
        <div className="flex items-center gap-2.5">
          <span
            className="w-3 h-3 rounded-full flex-shrink-0"
            style={{ backgroundColor: TRAFFIC_HEX[aow.ratingKey] || TRAFFIC_HEX.unknown }}
          />
          <span
            className="text-sm font-bold"
            style={{ color: AOW_CARD_COLORS.header.text }}
          >
            {aow.name}
          </span>
          {aow.resultCount > 0 && (
            <span className="text-xs opacity-60" style={{ color: AOW_CARD_COLORS.header.text }}>
              ({aow.resultCount} results)
            </span>
          )}
        </div>
        <span
          className="text-sm font-bold tabular-nums flex items-center gap-1"
          style={{ color: TRAFFIC_HEX[aow.ratingKey] || TRAFFIC_HEX.unknown }}
        >
          {aow.achievementPct != null ? `${Math.round(aow.achievementPct)}%` : '—'}
          {targetNote && (
            <span className="text-[9px] font-normal opacity-60">{targetNote}</span>
          )}
        </span>
      </div>

      {/* Content: Outputs + Outcomes side by side */}
      <div className="p-4 bg-white/50">
        {!hasOutputs && !hasOutcomes ? (
          <p className="text-xs text-gray-400 italic text-center py-4">
            No indicator data available for this Area of Work.
          </p>
        ) : (
          <div className={`flex gap-4 ${hasOutputs && hasOutcomes ? 'flex-col md:flex-row' : ''}`}>
            {hasOutputs && renderBox(`High Level Outputs (${outputGroup.length})`, outputGroup, AOW_CARD_COLORS.outputs)}
            {hasOutcomes && renderBox(`Intermediate Outcomes (${iocItems.length})`, iocItems, AOW_CARD_COLORS.outcomes)}
          </div>
        )}
      </div>
    </div>
  );
}
